import request from '@/utils/request'
import authRouterMap from '@/router/authRouterMap'

// 动态处理子项目路由前缀
function spaRoutesBuild (routes) {
  routes.forEach(router => {
    try {
      if (router.path.trim() === '/') {
        if (router.children && router.children.length > 0) {
          spaRoutesBuild(router.children)
        }
      } else {
        if (router.path.trim()[0] === '/' && router.meta && router.meta.app && router.meta.app.trim() !== '') {
          router.path = '/' + router.meta.app.trim() + router.path
        }
      }
    } catch (e) {
      console.log(e)
    }
  })
  return routes
}

const spaRoutes = spaRoutesBuild(JSON.parse(JSON.stringify(authRouterMap)))
console.log('spaRoutes', spaRoutes)

// 根据环境变量设置是否使用本地路由菜单
const useLocalAuthMenu = process.env.VUE_APP_USE_LOCAL_AUTH_MENU

// export function login (username, password) {
//   return new Promise(resolve => {
//     resolve({
//       data: 'token55454'
//     })
//   })
//   /*
//   return request({
//     url: '/user/login',
//     method: 'post',
//     data: {
//       username,
//       password
//     }
//   })
//   */
// }

// export function getInfo (token) {
//   return new Promise(resolve => {
//     resolve({
//       data: {
//         name: 'admin',
//         avatar: '',
//         userId: '13'
//       }
//     })
//   })
//   /*
//   return request({
//     url: '/user/info',
//     method: 'get',
//     params: { token }
//   })
//   */
// }

// export function logout () {
//   return request({
//     url: '/user/logout',
//     method: 'post'
//   })
// }

/**
 * 获取权限菜单
 * @returns {Promise<any>}
 */
export function getMenus () {
  if (useLocalAuthMenu === 'true') {
    return new Promise(resolve => {
      resolve({
        data: spaRoutes
      })
    })
  } else {
    return request({
      url: '/user/menus',
      method: 'post'
    })
  }
}

export function login (username, password) {
  return request({
    url: '/ssoUserLogin/v1/login',
    method: 'post',
    data: {
      userName: username,
      password: password
    }
  })
}

export function logout () {
  return request({
    url: '/ssoUserLogin/logout',
    method: 'post'
  })
}

export function getInfo () {
  return request({
    url: '/system/main?t=' + Math.random() + '&projectCode=SSO',
    method: 'get'
  })
}

export function getPublicKey () {
  return request({
    url: '/ssoUserLogin/getPubKey',
    method: 'post',
    async: false
  })
}
